<template>

    <div class="container">

        <div class="mb-2">
            <inertia-link :href="route('admin.products.index')">
                <i class="bi bi-arrow-left"></i>
                {{ __('Zur Übersicht') }}
            </inertia-link>
        </div>

        <div class="mb-4">

            <template v-if="parentProduct">
                <h1>
                    {{ __('Variante bearbeiten') }}
                </h1>
                <h2>
                    {{ __('Hauptprodukt: ') }}
                    <inertia-link :href="route('admin.products.edit', parentProduct)">
                        {{ parentProduct.name }}
                    </inertia-link>
                </h2>
            </template>
            <template v-else>
                <h1>{{ __('Produkt bearbeiten') }}</h1>
            </template>

            <h2 class="h5 text-muted">{{ form.name }}</h2>
            <p>
                <a :href="product.permalink" target="_blank">{{ product.permalink }}</a>
            </p>
        </div>

        <form @submit.prevent="form.put(route('admin.products.update', product))">
            <form-fields :form="form" 
                         :product="product" 
                         :currencies="currencies" 
                         :price-type-options="priceTypeOptions" 
                         :order-units="orderUnits" 
                         :category-tree="categoryTree" 
                         :suppliers="suppliers"
                         />
        </form>
    </div>

</template>

<script>
    import FormFields from './FormFields';

    export default {

        props: [
            'product',
            'variants',
            'parentProduct',
            'currencies',
            'orderUnits',
            'priceTypeOptions',
            'categoryTree',
            'suppliers',
        ],
        mounted() {
//            this.$inertia.on('before', (event) => {
//                return confirm('Are you sure you want to navigate away?')
//            })
        },
        data() {
            return {
                form: this.$inertia.form({
                    name: this.product.name,
                    slug: this.product.slug,
                    sku: this.product.sku,
                    parent_id: this.product.parent_id,
                    enabled: this.product.enabled,
                    main_image_id: this.product.main_image_id,
                    supplier_id: this.product.supplier_id,
                    supplier_pid: this.product.supplier_pid,
                    supplier_alt_pid: this.product.supplier_alt_pid,
                    manufacturer_pid: this.product.manufacturer_pid,
                    available_from: this.product.available_from ? moment(this.product.available_from).format('YYYY-MM-DDTHH:mm') : null,
                    available_until: this.product.available_until ? moment(this.product.available_until).format('YYYY-MM-DDTHH:mm') : null,
                    free_delivery: this.product.free_delivery,
                    volume: this.product.volume,
                    width: this.product.width,
                    depth: this.product.depth,
                    length: this.product.length,
                    weight: this.product.weight,
                    manage_stock: this.product.manage_stock,
                    stock_quantity: this.product.stock_quantity,
                    restock_date: this.product.restock_date,
                    quantity_min: this.product.quantity_min,
                    quantity_max: this.product.quantity_max,
                    quantity_interval: this.product.quantity_interval,
                    order_unit_id: this.product.order_unit_id,
                    content_unit_id: this.product.content_unit_id,
                    content_units_per_order_unit: this.product.content_units_per_order_unit,
                    price_quantity: this.product.price_quantity,
                    ean: this.product.ean,
                    release_date: this.product.release_date ? moment(this.product.release_date).format('YYYY-MM-DDTHH:mm') : null,
                    mdr_classified: this.product.mdr_classified,
                    hazardous_material: this.product.hazardous_material,
                    meta_title: this.product.meta_title,
                    meta_description: this.product.meta_description,
                    template: this.product.template,
                    contact_email: this.product.contact_email,
                    delivery_policy: this.product.delivery_policy,
                    purchase_note: this.product.purchase_note,
                    refund_policy: this.product.refund_policy,
                    return_policy: this.product.return_policy,
//                    sales: this.product.sales,
                    excerpt: this.product.excerpt,
                    description: this.product.description,
                    top_seller: this.product.top_seller,
                    write_protected: this.product.write_protected,
                    keywords: this.product.keywords,
                    categories: this.product.categories,
                    attachments: this.product.attachments,
                    properties: this.product.properties,
                    product_prices: this.product.product_prices,
                    variants: this.variants,
                }),
            }
        },
        components: {
            FormFields,
        },
        methods: {
            submit() {
                this.$inertia.post(this.route('admin.products.update', this.product));
            },
        },
    }
</script>